import * as React from "react";
import { Box, Grid, Typography } from "@mui/material";
import { Add } from "@mui/icons-material";
import { translate } from "../../../../../../translate/translate";
import { buildMonthGrid, CalendarCell, groupHolidaysByDate, MONTH_LABELS, WEEKDAY_LABELS } from "./calendar-utils";
import { Holiday } from "../../../../../../services/npi-holiday-service";
import NpiCalendarDayCellComponent from "./npi-calendar-day-cell.component";

interface NpiCalendarMonthGridProps {
    country: "BRASIL" | "CHINA";
    year: number;
    month: number;
    holidays: Holiday[];
    onAddHoliday: (country: "BRASIL" | "CHINA") => void;
    compact?: boolean;
    showHeader?: boolean;
}

const NpiCalendarMonthGridComponent: React.FC<NpiCalendarMonthGridProps> = ({
    country, year, month, holidays, onAddHoliday, compact, showHeader = true,
}) => {
    const holidaysByDate = groupHolidaysByDate(holidays);
    const rawWeeks = buildMonthGrid(year, month, holidaysByDate);
    const buildBlankWeek = (): CalendarCell[] => Array.from({ length: 7 }, () => ({ day: null, dateKey: null, holidays: [], isWeekend: false }));
    const weeks = rawWeeks.length >= 6 ? rawWeeks: [...rawWeeks, ...Array.from({ length: 6 - rawWeeks.length }, buildBlankWeek)];

    return (
        <Box sx={{ border: "1px solid #A9BCF5", borderRadius: "12px", p: compact ? 1.5 : 2, backgroundColor: "#FFFFFF" }}>
            {showHeader && (
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1.5, width: "100%", flexWrap: "wrap", rowGap: 0.5 }}>
                    <Typography sx={{ fontWeight: 700, fontSize: compact ? 14 : 16, color: "#1F2937" }}>
                        {country === "BRASIL" ? "🇧🇷" : "🇨🇳"} {MONTH_LABELS[month]}{!compact ? ` ${year}` : ""}
                    </Typography>
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                            width: "fit-content",
                            flexShrink: 0,
                            flexGrow: 0,
                        }}
                        onClick={() => onAddHoliday(country)}>
                        <Add fontSize="small" sx={{ color: "#003FFB" }} />
                        <Typography sx={{ fontWeight: 700, fontSize: 13, color: "#003FFB", whiteSpace: "nowrap" }}>
                            {translate.t("add_holiday").toUpperCase()}
                        </Typography>
                    </Box>
                </Box>
            )}
            <Grid container columns={7} spacing={0.5} sx={{ mb: 0.5 }}>
                {WEEKDAY_LABELS.map((label) => (
                    <Grid size={1} key={label} sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <Typography sx={{ fontSize: 11, color: "#8A94A6", fontWeight: 700 }}>{label}</Typography>
                    </Grid>
                ))}
            </Grid>
            {weeks.map((week, weekIndex) => (
                <Grid container columns={7} spacing={0.5} key={weekIndex} sx={{ mb: 0.5 }}>
                    {week.map((cell, cellIndex) => (
                        <Grid size={1} key={cellIndex}>
                            <NpiCalendarDayCellComponent cell={cell} compact={compact} />
                        </Grid>
                    ))}
                </Grid>
            ))}
        </Box>
    );
};

export default NpiCalendarMonthGridComponent;